/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type { CcofPracticeInfo } from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type getApiCcofPracticeIdPracticeResponse200 = {
  data: CcofPracticeInfo;
  status: 200;
};

export type getApiCcofPracticeIdPracticeResponse401 = {
  data: void;
  status: 401;
};

export type getApiCcofPracticeIdPracticeResponse403 = {
  data: void;
  status: 403;
};

export type getApiCcofPracticeIdPracticeResponse404 = {
  data: void;
  status: 404;
};

export type getApiCcofPracticeIdPracticeResponseSuccess =
  getApiCcofPracticeIdPracticeResponse200 & {
    headers: Headers;
  };
export type getApiCcofPracticeIdPracticeResponseError = (
  | getApiCcofPracticeIdPracticeResponse401
  | getApiCcofPracticeIdPracticeResponse403
  | getApiCcofPracticeIdPracticeResponse404
) & {
  headers: Headers;
};

export const getGetApiCcofPracticeIdPracticeUrl = (practiceId: string) => {
  return `/api/ccof/${practiceId}/practice`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 *
 * The practice id must be a valid practice id.
 * @summary Retrieves practice info by practice id.
 */
export const getApiCcofPracticeIdPractice = async (
  practiceId: string,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiCcofPracticeIdPracticeResponseSuccess> => {
  return authenticatedClient<getApiCcofPracticeIdPracticeResponseSuccess>(
    getGetApiCcofPracticeIdPracticeUrl(practiceId),
    {
      ...options,
      method: "GET",
    },
  );
};
